// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner--spinner--e-s7-","graphic":"Spinner--graphic--32oxm","spin":"Spinner--spin--ST7qM"};